import { Component, Inject, Input, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviderModel, DeviderType, svgData } from 'simpo-component-library';

@Component({
  selector: 'app-divider-list',
  templateUrl: './divider-list.component.html',
  styleUrls: ['./divider-list.component.scss']
})
export class DividerListComponent {
  constructor(public dialogRef: MatDialogRef<DividerListComponent>) { }


  @Input() data: any
  Object = Object
  dividerList = svgData;

  dividerData?: DeviderModel;
  ngOnInit() {
    this.dividerData = this.data?.data
    console.log(this.dividerList)
  }

  closeDialog() {
    this.dialogRef.close();
  }
  current: any;
  changeDivider(svgData: any) {
    if (this, this.dividerData)
      this.dividerData.deviderType = svgData;
    this.current = svgData
  }

}
